import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, SectionHeading } from "@/components/Reveal";

const FAQS = [
  {
    q: "Can VoiceLens AI read handwritten text?",
    a: "Yes. VoiceLens uses advanced vision AI trained to read handwriting — letters, notes, cards, and even curved medicine labels — then reads them aloud in a natural voice.",
  },
  {
    q: "Does it work offline?",
    a: "Core camera reading and text-to-speech work offline, so you're never stuck without a connection. AI Explain Mode uses the cloud for deeper summaries and needs an internet connection.",
  },
  {
    q: "Can it explain legal documents?",
    a: "Yes. AI Explain Mode turns legal, medical, and financial language into plain-English summaries you can listen to. It helps you understand documents, though it's not a substitute for professional legal advice.",
  },
  {
    q: "Is my information private?",
    a: "Absolutely. Documents are processed securely and images are deleted immediately after reading. We never store, sell, or share your personal documents. Privacy protection is built into every plan.",
  },
  {
    q: "Does it support multiple languages?",
    a: "Yes. VoiceLens reads and speaks in many major languages, and can translate printed text from one language and read it aloud in another.",
  },
  {
    q: "Can I use voice commands?",
    a: "Voice control is at the heart of VoiceLens. Say “Read this,” “What does this say?,” “Explain this,” or “Read my screen” — no precise tapping required.",
  },
];

export default function Faq() {
  return (
    <section id="faq" className="mx-auto max-w-4xl px-5 py-24 sm:px-8 lg:py-32" aria-labelledby="faq-heading">
      <span id="faq-heading" className="sr-only">Frequently asked questions</span>
      <SectionHeading
        align="center"
        eyebrow={{ index: "07", label: "FAQ" }}
        title={<>Questions, <span className="text-glow-gradient">answered plainly.</span></>}
      />

      <Reveal delay={0.15}>
        <Accordion type="single" collapsible className="mt-12 space-y-4" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`faq-${i}`}
              className="glass-panel card-glow rounded-2xl border border-[#00D4FF]/15 px-6"
            >
              <AccordionTrigger
                data-testid={`faq-question-${i}`}
                className="py-6 text-left font-display text-base font-bold text-white hover:text-[#00D4FF] hover:no-underline sm:text-lg"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-answer-${i}`}
                className="pb-6 text-base leading-relaxed text-slate-300"
              >
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </section>
  );
}
